module.exports = __webpack_public_path__ + "assets/media/morning.c4540d0d.mp3";